import { render, staticRenderFns } from "./MyLiteFormDesigntime.vue?vue&type=template&id=19a3eeca&scoped=true&"
import script from "./MyLiteFormDesigntime.vue?vue&type=script&lang=js&"
export * from "./MyLiteFormDesigntime.vue?vue&type=script&lang=js&"
import style0 from "./MyLiteFormDesigntime.vue?vue&type=style&index=0&id=19a3eeca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a3eeca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19a3eeca')) {
      api.createRecord('19a3eeca', component.options)
    } else {
      api.reload('19a3eeca', component.options)
    }
    module.hot.accept("./MyLiteFormDesigntime.vue?vue&type=template&id=19a3eeca&scoped=true&", function () {
      api.rerender('19a3eeca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/commonComponent/MyLiteFormDesigntime.vue"
export default component.exports